export const DISALLOW_FREE_CANCELLATION_EXPERIENCE_IDS = new Set<string>([
  // tour-4f7e366d-817d-40f2-b3d0-a9a47b156426
  // Qatar return economy flights
  '987638be-ef6e-48ac-bb6d-9c41520b90a1',
  // Qatar return business class flights
  '2b44f138-2d94-4296-bcdc-187d731d8db3',

  // tour-f140afb3-543e-495f-8fdf-fd0a6038cd7d
  // Qatar return economy flights
  'f7a70068-5f93-45c1-9341-3def36be18d3',
  // Qatar return business class flights
  '95f99fcb-410f-4bd3-aaa9-8f266559a21e',

  // tour-89e5f38a-ff81-47f1-96d9-bdd611c13dcb
  // Qatar return economy flights
  'b1b846e1-5359-4009-bd96-64ea381cddb7',
  // Qatar return business class flights
  'db507097-6199-4ea9-868b-edc55c3002bc',
])

export function shouldShowFreeCancellationForTourExperience(
  experience: App.Tours.TourExperience | undefined,
): boolean {
  if (!experience) return false
  if (DISALLOW_FREE_CANCELLATION_EXPERIENCE_IDS.has(experience.id)) return false
  return true
}
